export default __webpack_public_path__ + "static/media/News & Announcements.f971277d.svg";